const modules = [
	{
		title: 'BASICS YOGA',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/yfurvglzesfshepyvfip',
		desc: `In this module, you'll master Visual Studio Code basics. In just one minute, I'll help you migrate all your settings and keyboard shortcuts from your previous editor to VSCode. You can migrate from Vim, Sublime, Atom, Eclipse, IntelliJ/JetBrains IDE, Xcode, and about 20 other editors. I've got you covered. Jump right in.`,
		lessons: [
			{
				title: '<strong>BASICS</strong><span>: </span>VSCode Course Introduction',
				length: '01:47',
				video: '297488944',
			},
			{ title: '<strong>BASICS</strong><span>: </span>VSCode User Interface KnowHow', length: '02:18' },
			{
				title: '<strong>BASICS</strong><span>: </span>Custom VSCode Theme — Shades of Purple',
				length: '02:41',
				video: '297489110',
			},
			{ title: '<strong>BASICS</strong><span>: </span>The Command Palette To The Rescue', length: '01:05' },
			{ title: '<strong>BASICS</strong><span>: </span>Keymaps - Help You Switch Today', length: '01:07' },
			{
				title: '<strong>BASICS</strong><span>: </span>Switch From Sublime/Vim/Atom/JetBrains IDE',
				length: '01:07',
			},
			{ title: '<strong>BASICS</strong><span>: </span>Fixing Things You Break', length: '03:20' },
		],
	},
	{
		title: 'SETTINGS NINJA',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/nrxedwcmn2ptettvx1n3',
		desc: `I'll help you customize the VSCode interface <i>the way you like it</i>. After setting a custom theme, custom file icons, I'll share the code fonts I like/use. Both free and paid options. Then we'll do away with extra UI elements, fine-tune the whitespace and cursor setup.`,
		lessons: [
			{
				title: '<strong>SETTINGS</strong><span>: </span>VSCode Settings UI vs Settings.JSON',
				length: '02:49',
				video: '297489416',
			},
			{
				title: '<strong>SETTINGS</strong><span>: </span>Basic of Settings In Case You Missed It',
				length: '01:40',
			},
			{ title: '<strong>SETTINGS</strong><span>: </span>Setting up an Icon Theme', length: '01:18' },
			{ title: '<strong>SETTINGS</strong><span>: </span>Custom Code Font FTW', length: '04:49' },
			{ title: '<strong>SETTINGS</strong><span>: </span>Set up Cursor & UI Ninja', length: '02:11' },
			{ title: '<strong>SETTINGS</strong><span>: </span>UI + WhiteSpace Commando Part 1', length: '05:25' },
			{ title: '<strong>SETTINGS</strong><span>: </span>User Interface Setup Part 2', length: '04:27' },
			{ title: '<strong>SETTINGS</strong><span>: </span>Powerful Custom File Association', length: '02:28' },
		],
	},
	{
		title: 'POWER USER WORKFLOWS',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/xd4ex7cmr1xg0crkh9va',
		desc: `The fun begins here. Excellent power user workflows in this module. Each video here will set you up for good. You'll be hacking around with different files, palettes, and panels all with different keyboard shortcuts. I'll help you bend VSCode to your will.`,
		lessons: [
			{
				title: '<strong>WORKFLOWS</strong><span>: </span>File Handling Yoga Power User Workflows',
				length: '03:27',
			},
			{
				title: '<strong>WORKFLOWS</strong><span>: </span>Keybindings & Keyboard Shortcuts Editor',
				length: '04:38',
			},
			{ title: '<strong>WORKFLOWS</strong><span>: </span>File Editing Power User Workflows', length: '09:10' },
			{
				title: '<strong>WORKFLOWS</strong><span>: </span>Power Navigation Go To File | Symbol | View',
				length: '04:53',
			},
			{ title: '<strong>WORKFLOWS</strong><span>: </span>Macros Automate Repetitive Actions', length: '03:55' },
			{
				title: '<strong>WORKFLOWS</strong><span>: </span>Programming Productivity with Zen Mode',
				length: '01:16',
				video: '297492750',
			},
			{ title: '<strong>WORKFLOWS</strong><span>: </span>Set up Code Spell Checks FTW', length: '03:38' },
			{ title: '<strong>WORKFLOWS</strong><span>: </span>Snippets Intro + Snippet Creation', length: '08:27' },
			{
				title: '<strong>WORKFLOWS</strong><span>: </span>Use Code CLI (Command Line Interface) Like a Pro',
				length: '03:43',
			},
			{ title: '<strong>WORKFLOWS</strong><span>: </span>Search And Replace Anything Anywhere', length: '05:57' },
			{
				title: '<strong>WORKFLOWS</strong><span>: </span>Changing Focus from Editor to Sidebar & Back',
				length: '00:50',
			},
		],
	},
	{
		title: 'HTML/CSS THE WEB DEVELOPER',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/juo1jddvtqi2bl2vuldl',
		desc: `Every web developer has to learn HTML & CSS. There's no way around it. In this module, I'll show you how powerful VSCode + Emmet integration works. You don't have to install it, it comes built-in. We'll go over all sorts of custom HTML/CSS workflows and extensions setup.`,
		lessons: [
			{ title: '<strong>HTML</strong><span>: </span>Emmet Basics + Cheat Sheet', length: '03:02' },
			{ title: '<strong>Emmet</strong><span>: </span>Building Web Pages in a Jiffy', length: '02:52' },
			{ title: '<strong>Emmet</strong><span>: </span>Multiply & NumberingNumber', length: '05:02' },
			{ title: '<strong>Emmet</strong><span>: </span>Element Relations (Sibling/Child)', length: '05:02' },
			{ title: '<strong>Emmet</strong><span>: </span>One Single Line to a Web Page', length: '02:08' },
			{ title: '<strong>Emmet</strong><span>: </span>Tab Triggered Custom Setup', length: '01:18' },
			{ title: '<strong>HTML</strong><span>: </span>Tag Highlight + Customization Like a Pro', length: '02:27' },
			{
				title: '<strong>HTML</strong><span>: </span>Auto Formatting + Insert New Line Workflow',
				length: '03:45',
			},
			{ title: '<strong>HTML</strong><span>: </span>Favorite Extensions Review & Setup', length: '02:46' },
			{ title: '<strong>CSS</strong><span>: </span>Emmet Basics Introduction + Cheat Sheet', length: '01:05' },
			{ title: '<strong>CSS</strong><span>: </span>Easy Property/Value Fuzzy Search', length: '01:02' },
			{ title: '<strong>CSS</strong><span>: </span>Unit Manipulation: rem, em, px, %', length: '02:45' },
			{
				title: '<strong>CSS</strong><span>: </span>Value Bumping — Decrease/Increase With Ease',
				length: '03:15',
			},
			{ title: '<strong>CSS</strong><span>: </span>Value Bumping — Keyboard Shortcuts Setup', length: '01:09' },
			{
				title: '<strong>CSS</strong><span>: </span>Color Highlight Extension + Custom Settings',
				length: '01:23',
			},
		],
	},
	{
		title: 'Git/GitHub + Open Source Tips',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/evtbl1jyp3vvq3e5hifo',
		desc: `As a full-time open source developer Git version control system and GitHub Pull Requests, Collaboration, Code Reviews are critical to my dev-setup. That's what I'll share in this module. How to be an awesome open source developer, write better Git Commit Messages, and set up the Git Lens. We'll also review Pug setup and customizing VSCode Breadcrumbs.`,
		lessons: [
			{ title: '<strong>GIT</strong><span>: </span>VSCode Git Integration Intro', length: '03:37' },
			{ title: '<strong>GIT</strong><span>: </span>Power User Workflow with Git Range Select', length: '03:30' },
			{ title: '<strong>GIT</strong><span>: </span>Favorite Extensions Review & Setup', length: '03:57' },
			{ title: '<strong>GIT</strong><span>: </span>Git Config & GitIgnore files Syntax', length: '01:21' },
			{ title: '<strong>GIT</strong><span>: </span>Setting up the amazing  Git Lens Extension', length: '02:43' },
			{
				title: '<strong>GIT</strong><span>: </span>Reduce Git Lens Battery Footprint + Custom Settings',
				length: '01:34',
			},
			{ title: '<strong>GIT</strong><span>: </span>GitHub Pull Requests + Review Workflow', length: '05:22' },
			{ title: '<strong>PUG</strong><span>: </span>Language set up for Pug Templating', length: '03:39' },
			{ title: '<strong>BREADCRUMBS</strong><span>: </span>All You Need To Know', length: '04:22' },
		],
	},
	{
		title: 'Pro Markdown Workflow Setup',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/evtbl1jyp3vvq3e5hifo',
		desc: `I love Markdown. I learned it for writing GitHub README.md files, but it has changed my life for good. This site, my emails, newsletters, blog posts all of that is written in Markdown. This module has a single ~15-minute video which is a mini-course in itself on perfecting your setup for writing Markdown with VSCode. Take a look and tell me that's not tasty enough?!`,
		lessons: [
			{ title: '<strong>MARKDOWN</strong><span>: </span>Basic Syntax', length: '01:11' },
			{
				title: '<strong>MARKDOWN</strong><span>: </span>Customize for More Control + Suggestions',
				length: '0 1:50',
			},
			{ title: '<strong>MARKDOWN</strong><span>: </span>As the Default Language', length: '02:40' },
			{ title: '<strong>MARKDOWN</strong><span>: </span>Linting + Bug Fixing Automation', length: '04:13' },
			{ title: '<strong>MARKDOWN</strong><span>: </span>Custom Linting Rules Setup', length: '03:40' },
			{
				title: '<strong>MARKDOWN</strong><span>: </span>Preview Enhancements — Make it Like GitHub',
				length: '01:10',
			},
			{
				title: '<strong>MARKDOWN</strong><span>: </span>Auto Formatting Single Table + All Tables',
				length: '01:40',
			},
			{ title: '<strong>MARKDOWN</strong><span>: </span>TODO Lists with Checkboxes', length: '01:40' },
			{ title: '<strong>MARKDOWN</strong><span>: </span>Setup Word Counting', length: '01:00' },
			{
				title: '<strong>MARKDOWN</strong><span>: </span>Auto Numbering, Mathematics, Table of Contents',
				length: '03:23',
			},
			{
				title: '<strong>MARKDOWN</strong><span>: </span>Keybindings Fixes + Custom Keyboard shortcuts ',
				length: '01:43',
			},
		],
	},
	{
		title: 'EVERYTHING ABOUT JAVASCRIPT',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/v82tdmvvheat3pt920ch',
		desc: `JavaScript is eating the world, the web, the mobile, and even the Internet of Things tech space. You can write JavaScript functions and have them run in Microsoft Excel. Even VSCode is built with JavaScript, tell me about that. This is a hugely significant module, where I cover the JavaScript development setup. I'll take your hand, and we'll travel through different stages of JS Code debugging. We'll finally land on the VSCode debugging setup (which I bet you'll find the easiest of all). ES6+ Modern JavaScript, React, Frontend debugging with Chrome, custom extensions/snippets — this module has got you covered.`,
		lessons: [
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Intro to JavaScript with VSCode',
				length: '01:41',
				video: '297497294',
			},
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>Power User Workflows', length: '11:21' },
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>JSON Schema Definitions', length: '1:02' },
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>Basics of a JavaScript Application', length: '03:18' },
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>Interacting with a JavaScript File', length: '06:04' },
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Peeking & Definition Jumping + Keybindings',
				length: '05:21',
			},
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Multiple Terminals & Custom Keybindings',
				length: '05:21',
			},
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>ESLint Set up Like a Pro', length: '03:14' },
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Easiest Auto-formatting Prettier Setup',
				length: '06:10',
			},
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>Refactor Old to Modern JavaScript', length: '01:54' },
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>How Debugging Worked in Old Days', length: '01:42' },
			{ title: '<strong>JAVASCRIPT</strong><span>: </span>Debugging with VSCode on Steroids', length: '01:47' },
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Node Debugging With Nodemon - Part 1',
				length: '06:57',
			},
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Node Debugging With Nodemon - Part 2',
				length: '10:11',
			},
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Debugging ES6+ Modern JavaScript Code',
				length: '04:28',
			},
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Debugging with Chrome & React.js Framework',
				length: '04:19',
			},
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Intelligent Selection Expansion with Keyboard',
				length: '02:41',
			},
			{
				title: '<strong>JAVASCRIPT</strong><span>: </span>Eight Favorite Extensions Review & Setup',
				length: '05:53',
			},
		],
	},
	{
		title: 'PHP/WORDPRESS POWER USERS',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/lxmewdjrvrqebd4v4nry',
		desc: `I have been regularly contributing the WordPress Core software for over five years. PHP is one of my strong suits so when I switched over to VSCode the preference was to have a good PHP setup, where I can debug code with Xdebug, use Composer, build a coding-standards linting integration just like ESLint and have that awesome auto-formatting for PHP code. Took some time but I figured out some best possible 3rd party libraries + VSCode setup to do all that. After this module, you won't complain about PHP in VSCode.`,
		lessons: [
			{ title: '<strong>PHP</strong><span>: </span>15 Favorite Extensions Review & Setup', length: '07:46' },
			{ title: '<strong>PHP</strong><span>: </span>IntelliSense & IntelePhense Setup', length: '07:46' },
			{ title: '<strong>PHP</strong><span>: </span>Debugger, Namespace, Symbols Setup', length: '01:14' },
			{
				title: '<strong>PHP</strong><span>: </span>Coding standards with PHP Code Sniffer phpcs',
				length: '02:46',
			},
			{
				title: '<strong>PHP</strong><span>: </span>Complete Coding Standards Setup for WordPress',
				length: '05:50',
			},
			{
				title: '<strong>PHP</strong><span>: </span>Building a Custom Auto-formatting Setup for PHP/WP',
				length: '04:19',
			},
			{
				title: '<strong>PHP</strong><span>: </span>Documentation help with Auto-DocBlock Generation',
				length: '02:12',
			},
			{ title: '<strong>PHP</strong><span>: </span>Laravel Extensions + Snippets Review', length: '02:00' },
			{
				title: '<strong>PHP</strong><span>: </span>Symfony & CodeIgnitor Extensions + Snippets',
				length: '01:00',
			},
			{
				title: '<strong>PHP</strong><span>: </span>WordPress Toolbox, Search Docs + Keyboard shortcuts',
				length: '03:09',
			},
			{ title: '<strong>PHP</strong><span>: </span>Setting VSCode for PHP + WordPress', length: '13:17' },
			{
				title: '<strong>PHP</strong><span>: </span>File Association for Auto-indexing',
				length: '05:29',
				video: '297502910',
			},
			{ title: '<strong>PHP</strong><span>: </span>Custom Save & Run Setup + Review', length: '07:03' },
			{ title: '<strong>PHP</strong><span>: </span>Debugging Basics With VSCode', length: '03:54' },
			{ title: '<strong>PHP</strong><span>: </span>Debugging WordPress Code Like a Pro', length: '06:51' },
			{
				title: '<strong>PHP</strong><span>: </span>WordPress Custom Local Setup With Docker Containers',
				length: '06:01',
			},
			{ title: '<strong>PHP</strong><span>: </span>WordPress Xdebug Local Setup for Debugging', length: '01:22' },
			{ title: '<strong>PHP</strong><span>: </span>Listen for Xdebug inside VSCode Debugger', length: '04:41' },
			{
				title: '<strong>PHP</strong><span>: </span>Complete WordPress + VSCode Debugging Setup',
				length: '11:54',
			},
		],
	},
	{
		title: 'EXTENSION SETUP OF A PRO',
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_200,q_auto,f_auto/Placeholders/dfrsbd2qmlmcpld8bwvz',
		desc: `The best part of Visual Studio Code editor is that keeps out of your way. It can be as minimal as Sublime text and as powerful as an IDE like Eclipse, PhpStorm, etc. That's where the extensions ecosystem comes in. You'll find the best extensions community for VSCode, about 10,000 extensions to extend VSCode for Python, Go, C++, C#, Java, you name it. In this module, I'll review 50+ extension and customized setup.`,
		lessons: [
			{
				title: "<strong>EXTENSIONS</strong><span>: </span>Introduction & What's Where's & How's",
				length: '03:15',
			},
			{ title: '<strong>EXTENSIONS</strong><span>: </span>Go Programming Language Setup', length: '02:27' },
			{ title: '<strong>EXTENSIONS</strong><span>: </span>Python Programming Language Setup', length: '02:55' },
			{ title: '<strong>EXTENSIONS</strong><span>: </span>Ruby Programming Languages Setup', length: '01:24' },
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>C++, C# & 25+ Languages Syntax + Snippets',
				length: '07:11',
			},
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Installing & Reviewing Microsoft Extensions',
				length: '03:04',
			},
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Visual Studio Live Share - Visual Studio Code ',
				length: '02:04',
			},
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Impressive Azure Extension Pack & Azure CLI',
				length: '01:13',
			},
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Order-Case-Manipulate Power User Workflows',
				length: '06:08',
			},
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Better Highlighted Comments Like a Pro',
				length: '03:07',
			},
			{ title: '<strong>EXTENSIONS</strong><span>: </span>The Powerful Code Runner Extension', length: '01:52' },
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Managing Projects with the Project Manager',
				length: '02:21',
			},
			{
				title: '<strong>EXTENSIONS</strong><span>: </span>Backup and Sync your Settings + Setup',
				length: '06:06',
			},
			{ title: '<strong>EXTENSIONS</strong><span>: </span>50+ Extensions Reviewed & Installed', length: '05:00' },
		],
	},
];

export default modules;
